/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { OrganisationRoleFromJSON, OrganisationRoleToJSON, } from './OrganisationRole';
/**
 * Check if a given object implements the OrganisationAdministrativeUpdateRequest interface.
 */
export function instanceOfOrganisationAdministrativeUpdateRequest(value) {
    var isInstance = true;
    return isInstance;
}
export function OrganisationAdministrativeUpdateRequestFromJSON(json) {
    return OrganisationAdministrativeUpdateRequestFromJSONTyped(json, false);
}
export function OrganisationAdministrativeUpdateRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'organisationRoles': !exists(json, 'organisationRoles') ? undefined : (json['organisationRoles'].map(OrganisationRoleFromJSON))
    };
}
export function OrganisationAdministrativeUpdateRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'organisationRoles': value.organisationRoles === undefined ? undefined : (value.organisationRoles.map(OrganisationRoleToJSON))
    };
}
